.ux-guided-tour {
  display: block;
}

.ux-guided-tour__close-button {
  align-items: center;
  background: transparent;
  border: 0 none transparent;
  cursor: pointer;
  display: flex;
  height: 44px;
  justify-content: center;
  outline: 0 none transparent;
  position: absolute;
  right: 0;
  top: 0;
  width: 44px;

  ux-icon {
    flex: 0 0 auto;
    font-size: 15px;
  }

  &:focus,
  &:hover {
    outline: 0 none transparent;

    polygon {
      stroke: currentcolor;
      stroke-width: 2px;
    }
  }
}
